const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve an image URL. Relative paths starting with /api/uploads/
 * are prefixed with the backend URL so they're loadable in the browser.
 */
export function resolveImageUrl(url) {
  if (!url) return url;
  if (url.startsWith("/api/uploads/")) return `${BACKEND_URL}${url}`;
  return url;
}
